import { render } from "./PhoneModal.vue?vue&type=template&id=cf201a40&scoped=true"
import script from "./PhoneModal.vue?vue&type=script&lang=js"
export * from "./PhoneModal.vue?vue&type=script&lang=js"

import "./PhoneModal.vue?vue&type=style&index=0&id=cf201a40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf201a40"]])

export default __exports__